import { render, staticRenderFns } from "./AddFansToGroupDialog.vue?vue&type=template&id=2fc7d739&scoped=true"
import script from "./AddFansToGroupDialog.vue?vue&type=script&lang=js"
export * from "./AddFansToGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./AddFansToGroupDialog.vue?vue&type=style&index=0&id=2fc7d739&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7d739",
  null
  
)

export default component.exports